import { render, staticRenderFns } from "./UpdateDateExpired.vue?vue&type=template&id=fb93cdc6&scoped=true"
import script from "./UpdateDateExpired.vue?vue&type=script&lang=js"
export * from "./UpdateDateExpired.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb93cdc6",
  null
  
)

export default component.exports